import React from 'react'

const ErStoreCheck = () => {
  return <div>ErStoreCheck</div>
}

export default ErStoreCheck
